module.exports = __webpack_public_path__ + "img/shuhov.50e48e95.jpg";